import { useState } from "react";
import { useTranslation } from "react-i18next";

import type { DiscoveryState } from "shell/api/types";

import {
  lookupEmailOrgs,
  parseIdpConfigs,
} from "common-services/utils/idpDiscoveryUtils";

export const useIdpDiscovery = () => {
  const [state, setState] = useState<DiscoveryState>({ step: "email_input" });
  const { t } = useTranslation(["common"]);

  const lookupDomain = async (email: string) => {
    setState({ step: "loading" });
    const result = await lookupEmailOrgs(email);

    if (!result.ok) {
      return setState({
        step: "error",
        message: t(`common:idpDiscovery.${result.error}`),
      });
    }

    const idps = parseIdpConfigs(
      result.orgs.flatMap(o => o.identity_provider_config),
    );

    if (idps.length === 0) {
      return setState({
        step: "error",
        message: t("common:idpDiscovery.noSsoProviders"),
      });
    }

    setState({
      step: "idp_selection",
      email,
      idps,
    });
  };

  const reset = () => {
    setState({ step: "email_input" });
  };

  return { state, lookupDomain, reset };
};
